module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landscape-image"
  }, [_c('collection-image', {
    attrs: {
      "image": _vm.image
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d0dd8db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collection__Story__LandscapeImage.vue
// module id = 389
// module chunks = 1